import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDateTime = (dateTime: Date | string | undefined): string => {
  if (!dateTime) return ''
  return dayjs.utc(dateTime).local().format('DD-MM-YYYY [at] HH:mm')
}

export const truncateDescription = (text: string | undefined, maxLength: number = 160): string => {
  if (!text) return ''
  if (text.length <= maxLength) return text
  return text.substring(0, maxLength) + '...'
}
